<template>
    <div class="goods-list-page">
        <GeekQooSearch @search="setKeyword"></GeekQooSearch>
        <div class="top-title">
            <p>{{ category.title }}</p>
        </div>
        <div class="new-filter">
            <div class="filter-item" @click="showCategoryDrawer = true">
                <div class="filter-item-content">
                    <span>{{ currentCategoryText }}</span>
                    <van-icon name="arrow-down" size="16" />
                </div>
            </div>
            <div class="filter-item" @click="showFilterDrawer = true">
                <div class="filter-item-content">
                    <span>筛选</span>
                    <van-icon v-if="!isFilterLoading" name="filter-o" size="16" />
                    <van-loading v-else size="16px" />
                </div>
            </div>
        </div>

        <!-- 分类抽屉 -->
        <van-popup v-model="showCategoryDrawer" position="right" :style="{ width: '80%', height: '100%' }" :overlay="true"
            :close-on-click-overlay="true">
            <div class="drawer-content">
                <div class="drawer-header">
                    <h3>商品分类</h3>
                    <van-icon name="cross" size="20" @click="showCategoryDrawer = false" />
                </div>
                <div class="drawer-body">
                    <div class="category-filter">
                        <div class="category-tags">
                            <a :class="style.activeIndex == -1 ? 'active' : ''"
                                @click="styleChange({ id: null }, -1)">全部</a>
                            <a v-for="(item, index) in style.list" :key="index"
                                :class="style.activeIndex == index ? 'active' : ''" @click="styleChange(item, index)">
                                {{ item.title }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>

        <!-- 筛选抽屉 -->
        <van-popup v-model="showFilterDrawer" position="right" :style="{ width: '80%', height: '100%' }" :overlay="true"
            :close-on-click-overlay="true">
            <div class="drawer-content">
                <div class="drawer-header">
                    <h3>筛选条件</h3>
                    <van-icon name="cross" size="20" @click="showFilterDrawer = false" />
                </div>
                <div class="drawer-body">
                    <!-- 品牌筛选 -->
                    <div class="brand-filter" v-if="brandFilter.list.length > 0">
                        <div class="filter-header">
                            <h4>品牌筛选</h4>
                            <div v-if="brandFilter.list.length > 6" class="collapse-btn" @click="toggleBrandCollapse">
                                <span v-if="brandSelectedCount > 0">已选{{ brandSelectedCount }}项</span>
                                <span v-else>{{ collapseState.brand.expanded ? '收起' : '展开' }}</span>
                                <van-icon :name="collapseState.brand.expanded ? 'arrow-up' : 'arrow-down'" size="12" />
                            </div>
                        </div>
                        <div class="brand-list">
                            <div v-for="brand in displayedBrands" :key="brand.id"
                                :class="['brand-item', { 'active': brandFilter.selectedIds.includes(brand.id) }]"
                                @click="toggleBrandSelect(brand.id, $event)">
                                <img v-if="!brandFilter.selectedIds.includes(brand.id)" :src="brand.icon"
                                    :alt="brand.name" class="brand-icon" />
                                <span v-if="brandFilter.selectedIds.includes(brand.id)" class="brand-text">{{ brand.name }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 规格筛选 -->
                    <div class="spec-filter" v-if="specFilter.list.length > 0">
                        <div v-for="spec in specFilter.list" :key="spec.id" class="spec-group">
                            <div class="filter-header">
                                <h4>{{ spec.name }}</h4>
                                <div v-if="spec.value.length > 6" class="collapse-btn" @click="toggleSpecCollapse(spec.id)">
                                    <span v-if="getSpecSelectedCount(spec.id) > 0">已选{{ getSpecSelectedCount(spec.id) }}项</span>
                                    <span v-else>{{ getSpecCollapseState(spec.id) ? '收起' : '展开' }}</span>
                                    <van-icon :name="getSpecCollapseState(spec.id) ? 'arrow-up' : 'arrow-down'" size="12" />
                                </div>
                            </div>
                            <div class="spec-tags">
                                <a v-for="value in getDisplayedSpecValues(spec)" :key="value.id"
                                    :class="{ 'active': specFilter.selectedIds.includes(value.id) }"
                                    @click="toggleSpecSelect(value.id, $event)">
                                    {{ value.name }}
                                </a>
                            </div>
                        </div>
                    </div>


                    <div class="price-filter">
                        <h4>价格范围</h4>
                        <div class="price-inputs">
                            <input v-model="minPrice" class="item-input" placeholder="最低价" type="text" />
                            <span class="item-word">—</span>
                            <input v-model="maxPrice" class="item-input" placeholder="最高价" type="text" />
                        </div>
                    </div>
                </div>
                <div class="drawer-footer">
                    <van-button class="reset-btn" plain @click="resetFilter">重置</van-button>
                    <van-button class="confirm-btn" color="#6b4d9a" @click="confirmFilter">确定</van-button>
                </div>
            </div>
        </van-popup>
        <!--<div class="select-screening">-->
        <!--    <van-button-->
        <!--        :color="selectScreenActive===0?'#6b4d9a':'#999999'"-->
        <!--        class="item-button"-->
        <!--        round-->
        <!--        size="mini"-->
        <!--        @click="selectScreenList(0)"-->
        <!--    >-->
        <!--        0-1000-->
        <!--    </van-button>-->
        <!--    <van-button-->
        <!--        :color="selectScreenActive===1?'#6b4d9a':'#999999'"-->
        <!--        class="item-button"-->
        <!--        round-->
        <!--        size="mini"-->
        <!--        @click="selectScreenList(1)"-->
        <!--    >-->
        <!--        1001-3000-->
        <!--    </van-button>-->
        <!--    <van-button-->
        <!--        :color="selectScreenActive===2?'#6b4d9a':'#999999'"-->
        <!--        class="item-button"-->
        <!--        round-->
        <!--        size="mini"-->
        <!--        @click="selectScreenList(2)"-->
        <!--    >-->
        <!--        3001-5000-->
        <!--    </van-button>-->
        <!--    <van-button-->
        <!--        :color="selectScreenActive===3?'#6b4d9a':'#999999'"-->
        <!--        class="item-button"-->
        <!--        round-->
        <!--        size="mini"-->
        <!--        @click="selectScreenList(3)"-->
        <!--    >-->
        <!--        5001-10000-->
        <!--    </van-button>-->
        <!--</div>-->
        <van-list v-model="goodsPagination.loading" :finished="goodsPagination.finished" class="goods-list"
            finished-text="没有更多了" @load="getGoodsList">
            <div class="list-wrapper">
                <a v-for="(item, index) in goodsList" class="good-item" @click="toDetail(item)">
                    <div :style="`background:url(${item.thumb_arr.length > 0 ? item.thumb_arr[0] : item.thumb})`"
                        class="item-img"></div>
                    <div class="item-info">
                        <p v-if="item.bar_code" class="p1">组名：{{ item.bar_code ? item.bar_code : "暂无" }}</p>
                        <p class="p1">货号：{{ item.title }}</p>
                        <p class="p1">名称：{{ item.sub_title }}</p>
                        <p v-if="item.price" class="p2">￥{{ item.price }}</p>
                        <p v-else class="p2">暂无报价</p>
                    </div>
                </a>
            </div>
        </van-list>
    </div>
</template>

<script>
// 引入mixins
import mixins_config from "@/mixins/config.js";
// 引入组件
import GeekQooSearch from "@/components/GeekQooSearch";
// 引入接口
import { GOODS_GROUP, GOODS_LIST, GET_FILTER_CONFIGS } from "@/api/dataProvider.js";
import wx from "weixin-js-sdk";

export default {
    name: "GoodsList",
    mixins: [mixins_config],
    components: { GeekQooSearch },
    data() {
        return {
            keyword: "",
            // 分类抽屉显示状态
            showCategoryDrawer: false,
            // 筛选抽屉显示状态
            showFilterDrawer: false,
            // 分类
            categoryIdList: "",
            category: {
                title: "",
                activeId: ""
            },
            // 风格
            style: {
                list: [],
                activeId: "",
                activeIndex: -1
            },
            // 最低价
            minPrice: "",
            // 最高价
            maxPrice: "",
            // 筛选按钮选中
            selectScreenActive: -1,
            // 搜索防抖定时器
            searchTimer: null,
            // 确认筛选防抖定时器
            confirmTimer: null,
            // 请求状态管理
            isFilterLoading: false,
            // 品牌筛选
            brandFilter: {
                list: [],
                selectedIds: []
            },
            // 规格筛选
            specFilter: {
                list: [],
                selectedIds: []
            },
            // 折叠状态管理
            collapseState: {
                brand: {
                    expanded: false,
                    maxLines: 2
                },
                specs: {} // 使用对象存储每个规格组的折叠状态
            },
            // 商品分类
            goodsList: [],
            // 分页相关
            goodsPagination: {
                current: 1,
                loading: false,
                finished: false
            }
        };
    },
    computed: {
        // 计算品牌选中数量
        brandSelectedCount() {
            return this.brandFilter.selectedIds.length;
        },
        // 计算规格选中数量
        specSelectedCount() {
            return this.specFilter.selectedIds.length;
        },
        // 计算当前分类显示文案
        currentCategoryText() {
            if (this.style.activeIndex === -1) {
                return '全部分类';
            } else {
                const currentStyle = this.style.list[this.style.activeIndex];
                return currentStyle ? currentStyle.title : '全部分类';
            }
        },
        // 计算显示的品牌列表
        displayedBrands() {
            if (!this.brandFilter.list || this.brandFilter.list.length === 0) {
                return [];
            }
            // 如果品牌数量小于等于6个，或者已展开，显示全部
            if (this.brandFilter.list.length <= 6 || this.collapseState.brand.expanded) {
                return this.brandFilter.list;
            }
            // 否则只显示前6个
            return this.brandFilter.list.slice(0, 6);
        }
    },
    watch: {
        // 监听分类信息变化
        category: {
            handler(newVal) {
                if (newVal.title && wx && wx.miniProgram) {
                    wx.miniProgram.postMessage({
                        data: {
                            type: 'shareInfo',
                            title: newVal.title,
                            desc: '查看商品列表',
                            imageUrl: this.goodsList[0]?.thumb || '',
                            path: `/pages/index/index?url=${encodeURIComponent(`${window.location.origin}/#/goods-list?tags=${this.getCategoryTags()}`)}`
                        }
                    });
                }
            },
            deep: true,
            immediate: true
        }
    },
    activated() {
        if (this.$route.params.status != -1) {
            this.clearPagination();
            this.init();
            this.getGoodsList();
        }
    },
    created() {
        this.app.tabActive = 1;
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        // 清理定时器，防止内存泄漏
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
        if (this.confirmTimer) {
            clearTimeout(this.confirmTimer);
        }
    },
    methods: {
        getCategoryTags() {
            const tags = this.$route.query.tags || this.$route.query.id;
            if (Array.isArray(tags)) {
                return tags[0] || "";
            }
            return typeof tags === "string" ? tags : "";
        },
        getCategoryIdList() {
            const tags = this.getCategoryTags();
            if (!tags) {
                return [];
            }
            return tags
                .split("-")
                .map(Number)
                .filter((id) => Number.isFinite(id));
        },
        getCurrentCategoryId() {
            const ids = this.getCategoryIdList();
            return ids.length >= 2 ? ids[ids.length - 1] : null;
        },
        init() {
            // 路由获取分类层级ID
            this.categoryIdList = this.getCategoryIdList();
            this.category.activeId = this.getCurrentCategoryId();
            this.getGoodsGroup();
            this.getFilterConfigs()
        },
        // 获取商品分类
        getGoodsGroup() {
            let that = this;
            // 获取两级分类标题
            GOODS_GROUP({}, function (res) {
                if (res.data.code == 0) {
                    let currentList = res.data.data.group || [];
                    const titleList = [];

                    that.categoryIdList.forEach((categoryId) => {
                        const currentCategory = currentList.find((item) => item.id == categoryId);
                        if (!currentCategory) {
                            return;
                        }
                        titleList.push(currentCategory.title);
                        currentList = currentCategory.list || [];
                    });

                    that.category.title = titleList.join(" - ");
                }
            });
            // 获取风格列表
            GOODS_GROUP(
                {
                    id: this.getCategoryTags()
                },
                function (res) {
                    if (res.data.code == 0) {
                        that.style.list = res.data.data.group;
                    }
                }
            );
        },
        // 切换风格
        styleChange(item, index) {
            this.style.activeIndex = index;
            this.style.activeId = item.id;
            this.showCategoryDrawer = false;
            this.clearPagination();
            this.getFilterConfigs(); // 重新获取筛选配置
            this.getGoodsList();
        },
        // 筛选
        screenList() {
            this.clearPagination();
            this.getGoodsList();
        },
        // 选择筛选
        selectScreenList(type) {
            console.log(type);
            this.$loading.show();
            this.selectScreenActive = type;
            if (type === 0) {
                this.minPrice = 0;
                this.maxPrice = 1000;
            } else if (type === 1) {
                this.minPrice = 1001;
                this.maxPrice = 3000;
            } else if (type === 2) {
                this.minPrice = 3001;
                this.maxPrice = 5000;
            } else if (type === 3) {
                this.minPrice = 5001;
                this.maxPrice = 10000;
            }
            this.clearPagination();
            this.getGoodsList();
        },
        // 初始化分页信息
        clearPagination() {
            this.goodsPagination = {
                current: 1,
                loading: false,
                finished: false
            };
            this.goodsList = [];
        },
        // 设置关键词 - 添加防抖
        setKeyword(val) {
            this.keyword = val;
            // 清除之前的定时器
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            // 设置新的定时器，500ms后执行搜索
            this.searchTimer = setTimeout(() => {
                this.clearPagination();
                this.getFilterConfigs();
                this.getGoodsList();
            }, 500);
        },
        // 获取商品列表
        getGoodsList() {
            let that = this;
            GOODS_LIST(
                {
                    page: that.goodsPagination.current,
                    pageSize: 10,
                    // pid: 0,
                    keyword: that.keyword,
                    tags: that.getCurrentCategoryId(),
                    subTag: that.style.activeId,
                    minPrice: that.minPrice,
                    maxPrice: that.maxPrice,
                    spec_value_ids: that.getCombinedSpecValueIds()
                },
                function (res) {
                    if (res.data.code == 0) {
                        that.goodsPagination.loading = false;
                        // 列表有数据并且是第一页，那肯定是重复请求了，所以阻断掉
                        if (that.goodsList.length > 0 && res.data.data.current_page == 1) {
                            return false;
                        }
                        that.goodsList = that.goodsList.concat(res.data.data.data);
                        if (res.data.data.last_page > that.goodsPagination.current) {
                            that.goodsPagination.current += 1;
                        } else {
                            that.goodsPagination.finished = true;
                        }
                    }
                }
            );
        },
        // 跳转商品详情
        toDetail(item) {
            this.$router.push({
                name: "GoodDetail",
                params: { id: item.id }
            });
        },
        // 确定筛选 - 添加防抖
        confirmFilter() {
            this.showFilterDrawer = false;
            this.clearPagination();
            // 防抖处理，避免重复请求
            if (this.confirmTimer) {
                clearTimeout(this.confirmTimer);
            }
            this.confirmTimer = setTimeout(() => {
                this.getGoodsList();
            }, 300);
        },
        // 重置筛选
        resetFilter() {
            this.minPrice = "";
            this.maxPrice = "";
            this.brandFilter.selectedIds = [];
            this.specFilter.selectedIds = [];
        },
        // 切换品牌选择 - 优化数组操作
        toggleBrandSelect(brandId, event) {
            const selectedSet = new Set(this.brandFilter.selectedIds);
            if (selectedSet.has(brandId)) {
                selectedSet.delete(brandId);
            } else {
                selectedSet.add(brandId);
            }
            // 强制触发响应式更新，确保样式立即变化
            this.$set(this.brandFilter, 'selectedIds', Array.from(selectedSet));
            
            // 清除hover状态，确保样式立即更新
            this.$nextTick(() => {
                if (event && event.target) {
                    event.target.blur();
                    // 强制重新渲染该组件
                    this.$forceUpdate();
                }
            });
        },
        // 切换规格选择 - 优化数组操作
        toggleSpecSelect(valueId, event) {
            const selectedSet = new Set(this.specFilter.selectedIds);
            if (selectedSet.has(valueId)) {
                selectedSet.delete(valueId);
            } else {
                selectedSet.add(valueId);
            }
            // 强制触发响应式更新，确保样式立即变化
            this.$set(this.specFilter, 'selectedIds', Array.from(selectedSet));
            
            // 清除hover状态，确保样式立即更新
            this.$nextTick(() => {
                if (event && event.target) {
                    event.target.blur();
                    // 强制重新渲染该组件
                    this.$forceUpdate();
                }
            });
        },
        // 切换品牌折叠状态
        toggleBrandCollapse() {
            this.collapseState.brand.expanded = !this.collapseState.brand.expanded;
        },
        // 切换规格折叠状态
        toggleSpecCollapse(specId) {
            this.$set(this.collapseState.specs[specId], 'expanded', !this.collapseState.specs[specId].expanded);
        },
        // 获取合并的筛选值ID
        getCombinedSpecValueIds() {
            const allIds = [...this.brandFilter.selectedIds, ...this.specFilter.selectedIds];
            return allIds.length > 0 ? allIds.join(',') : '';
        },
        // 获取筛选项 - 添加请求状态管理
        getFilterConfigs() {
            let that = this;
            
            // 如果正在加载中，则跳过
            if (this.isFilterLoading) {
                return;
            }
            
            this.isFilterLoading = true;
            
            // 构建请求参数，优先使用category_id分类，没有时才使用keywords关键词
            let params = {};
            const currentCategoryId = that.getCurrentCategoryId();

            // 优先使用分类ID
            if (currentCategoryId) {
                params.category_id = currentCategoryId;
            } else if (that.keyword) {
                // 没有分类ID时使用关键词
                params.keywords = that.keyword;
            }

            GET_FILTER_CONFIGS(params, function (res) {
                that.isFilterLoading = false;
                if (res.data.code == 0) {
                    console.log(res.data.data);
                    // 批量更新筛选数据，减少响应式更新次数
                    that.$nextTick(() => {
                        that.brandFilter.list = res.data?.data?.data?.brand_filter || [];
                        that.specFilter.list = res.data?.data?.data?.specification_filter || [];
                        
                        // 初始化规格折叠状态
                        that.specFilter.list.forEach(spec => {
                            if (!that.collapseState.specs[spec.id]) {
                                that.$set(that.collapseState.specs, spec.id, {
                                    expanded: false,
                                    maxLines: 2
                                });
                            }
                        });
                    });
                }
            });
        },
        // 获取规格组已选数量
        getSpecSelectedCount(specId) {
            return this.specFilter.selectedIds.filter(id => this.specFilter.list.find(spec => spec.id === specId)?.value.map(v => v.id).includes(id)).length;
        },
        // 获取规格组折叠状态
        getSpecCollapseState(specId) {
            return this.collapseState.specs[specId]?.expanded;
        },
        // 获取显示的规格值列表
        getDisplayedSpecValues(spec) {
            if (!spec.value || spec.value.length === 0) {
                return [];
            }
            // 如果规格值数量小于等于6个，或者已展开，显示全部
            if (spec.value.length <= 6 || this.collapseState.specs[spec.id]?.expanded) {
                return spec.value;
            }
            // 否则只显示前6个
            return spec.value.slice(0, 6);
        }
    }
};
</script>

<style lang="scss">
.goods-list-page {
    background: #f5f5f5;
    min-height: 100vh;
    padding: 0 0 50px 0;

    .top-title {
        background: #6b4d9a;

        p {
            line-height: 35px;
            text-align: center;
            font-size: 10px;
            color: #fff;
        }
    }

    .new-filter {
        background: #fff;
        display: flex;
        align-items: center;
        box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);

        .filter-item {
            display: flex;
            align-items: center;
            line-height: 40px;
            flex: 1;
            cursor: pointer;

            &:hover {
                background-color: #f5f5f5;
            }

            .filter-item-content {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;

                span {
                    margin-right: 5px;
                    font-size: 14px;
                    color: #333;
                }
            }
        }
    }



    .screening {
        margin: 7px 0 0 0;
        padding: 0 17px;
        text-align: center;

        .item-input {
            vertical-align: middle;
            width: 123px;
            line-height: 24px;
            background: #f8f8f8;
            border: 1px solid #f8f8f8;
            border-radius: 15px;
            text-align: center;
            font-size: 12px;
            color: #333;
        }

        .item-word {
            vertical-align: middle;
            line-height: 24px;
            margin: 0 10px;
            font-size: 12px;
            color: #333;
        }

        .item-button {
            padding: 0 15px;
            vertical-align: middle;
            margin-left: 10px;
        }
    }

    .select-screening {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin: 7px 0 0 0;
        padding: 0 17px;

        .item-button {
            flex: 0 0 calc(25% - 5px);
            margin: 2.5px;
        }
    }

    .goods-list {
        padding: 0 8px;

        .list-wrapper {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .good-item {
                display: block;
                width: 176px;
                margin-top: 8px;
                background: #fff;
                box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);

                .item-img {
                    width: 100%;
                    height: 120px;
                    background-repeat: no-repeat !important;
                    background-size: cover !important;
                    background-position: center !important;
                }

                .item-info {
                    padding: 10px;

                    .p1 {
                        margin-bottom: 10px;
                        font-size: 10px;
                        color: #2d2d2d;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .p2 {
                        font-size: 10px;
                        font-weight: bold;
                        color: #f54a4a;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }

    // 抽屉样式
    .drawer-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #fff;

        .drawer-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 20px;
            border-bottom: 1px solid #eee;

            h3 {
                margin: 0;
                font-size: 16px;
                font-weight: 600;
                color: #333;
            }

            .van-icon {
                color: #999;
                cursor: pointer;
            }
        }

        .drawer-body {
            flex: 1;
            padding: 20px;
            overflow-y: auto;

            .category-filter,
            .price-filter,
            .brand-filter,
            .spec-filter {
                margin-bottom: 30px;

                .filter-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 15px;

                    h4 {
                        margin: 0;
                        font-size: 14px;
                        font-weight: 600;
                        color: #333;
                    }

                    .collapse-btn {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        color: #999;
                        font-size: 12px;

                        .van-icon {
                            margin-left: 5px;
                        }
                    }
                }

                h4 {
                    margin: 0 0 15px 0;
                    font-size: 14px;
                    font-weight: 600;
                    color: #333;
                }

                h5 {
                    margin: 0 0 10px 0;
                    font-size: 13px;
                    font-weight: 500;
                    color: #666;
                }
            }

            .category-tags {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;

                a {
                    flex: 0 0 calc(33.33% - 6px);
                    padding: 8px 16px;
                    border: 1px solid #eeeeee;
                    text-align: center;
                    font-size: 12px;
                    color: #333333;
                    background: #f5f5f5;
                    text-decoration: none;
                    box-sizing: border-box;

                    &:hover:not(.active) {
                        border-color: #6b4d9a;
                        color: #6b4d9a;
                    }

                    &.active {
                        border-color: #6b4d9a !important;
                        color: #6b4d9a !important;
                        background: rgba(107, 77, 154, 0.1) !important;
                    }
                }
            }

            // 品牌列表样式
            .brand-filter {
                .brand-list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;

                    .brand-item {
                        flex: 0 0 calc(33.33% - 6px);
                        height: 60px;
                        cursor: pointer;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        // 未选中状态 - 纯图片
                        &:not(.active) {
                            .brand-icon {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                display: block;
                            }
                        }

                        // 选中状态 - 和规格筛选样式一致
                        &.active {
                            padding: 8px 0;
                            border: 1px solid #6b4d9a;
                            background: rgba(107, 77, 154, 0.1);
                            color: #6b4d9a;

                            .brand-text {
                                font-size: 12px;
                                color: #6b4d9a;
                                text-align: center;
                            }
                        }

                        // &:hover:not(.active) {
                        //     opacity: 0.8;
                        // }
                    }
                }
            }

            // 规格标签样式（复用商品分类样式）
            .spec-group {
                margin-bottom: 20px;

                &:last-child {
                    margin-bottom: 0;
                }

                .spec-tags {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;

                    a {
                        flex: 0 0 calc(33.33% - 6px);
                        padding: 8px 16px;
                        border: 1px solid #eeeeee;
                        text-align: center;
                        font-size: 12px;
                        color: #333333;
                        background: #f5f5f5;
                        text-decoration: none;
                        box-sizing: border-box;
                        cursor: pointer;

                        // &:hover:not(.active) {
                        //     border-color: #6b4d9a;
                        //     color: #6b4d9a;
                        // }

                        &.active {
                            border-color: #6b4d9a !important;
                            color: #6b4d9a !important;
                            background: rgba(107, 77, 154, 0.1) !important;
                        }
                    }
                }
            }

            .price-filter {
                .price-inputs {
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    .item-input {
                        width: calc((100% - 30px) / 2);
                        height: 40px;
                        padding: 0 15px;
                        background: #f8f8f8;
                        border: 1px solid #f8f8f8;
                        text-align: center;
                        font-size: 14px;
                        color: #333;

                        &:focus {
                            outline: none;
                            border-color: #6b4d9a;
                        }
                    }

                    .item-word {
                        text-align: center;
                        width: 30px;
                        font-size: 14px;
                        color: #999;
                        font-weight: bold;
                    }
                }
            }
        }

        .drawer-footer {
            display: flex;
            gap: 15px;
            padding: 20px;
            border-top: 1px solid #eee;

            .reset-btn,
            .confirm-btn {
                flex: 1;
                height: 44px;
                border-radius: 8px;
                font-size: 16px;
            }

            .reset-btn {
                border-color: #ddd;
                color: #666;
            }
        }
    }
}
</style>
